import { prop } from '.';

export function resolveCategoryName(data: any) {
  return (
    prop(
      data,
      'publish.0.category_name',
      prop(data, 'content.0.name', prop(data, 'category_name', '')),
    ) || prop(data, 'category_name', '')
  );
}

export function resolveCategoryUrlString(data: any, byId?: any) {
  return (byId?prop(byId,`${data.redirect_category_id}.publish.0.url`):false) || prop(data, 'publish.0.url') || prop(data, 'url', '');
}
